/** A storage adapter represents some way of storing binary data for a {@link Repo}
 * @deprecated use {@link StorageAdapterInterface}
 *
 * @remarks
 * `StorageAdapter`s provide a key/value storage interface. The keys are arrays of strings
 * ({@link StorageKey}) and the values are binary blobs.
 */
export class StorageAdapter {
}
